<template>
    <div>

        <div v-if="init">
 
            <div class="pagebreak" v-for="marktime in filteredMarktimes">
                <MarktimePreviewTable
                    :user="getUser(marktime.user)"
                    :marktime="marktime"
                    :approvalUser="getUser(marktime.approvedBy)">
                </MarktimePreviewTable>
            </div>

        </div>

        <div v-else class="loader loader-dark loader-big ml-4 mt-4 mr-0 mb-0"></div>


    </div>
</template>

<script>
import { db, auth } from '@/firebase'
import { mapState } from "vuex";
import helper from '../helpers';

import MarktimePreviewTable from '@/components/MarktimePreviewTable.vue'

export default {
    data() {
        return {
            marktimes: null,
            date: {
                month: this.$route.params.month,
                year: this.$route.params.year
            }
        }
    },
    computed: {

        init() {
            if (this.marktimes && this.users) return true
            return false
        },

        ...mapState([
            'users',
        ]),

        marktimesWithNames() {
            if (this.init) {
                return this.marktimes.map(marktime => {
                    marktime.userName = this.getUser(marktime.user).name;
                    return marktime
                })
            }
        },

        filteredMarktimes() {
            if (this.init) {
                var marktimes = this.marktimesWithNames;

                marktimes = marktimes.filter(marktime => {
                    var user = this.getUser(marktime.user);
                    if (user.role !== 'superadmin') return true;
                    return false;
                });

                marktimes = marktimes.sort((a, b) => {
                    return a.userName.localeCompare(b.userName);
                });

                return marktimes;
            }
        }

    },

    components: {
        MarktimePreviewTable
    },

    methods: {
        getMarktimes() {

            this.loading = true
        
            db
            .collection('marktimes')
            .where('month', '==', parseFloat(this.date.month))
            .where('year', '==', parseFloat(this.date.year))
            .onSnapshot(query => {
                var marktimes = []
                query.forEach(function (doc) {
                    var marktime = doc.data()
                    marktime.id = doc.id
                    marktime = helper.mutateMarktime(marktime)
                    marktimes.push(marktime)
                });
                this.marktimes = marktimes
            })

        },

        getUser(uid) {
            return this.users.find(user => user.uid === uid)
        },

    },

    created() {
        this.getMarktimes()
        if (!this.users) this.$store.dispatch('getUsers')
    }
}
</script>

<style lang="scss" scoped>

    .pagebreak {
        border-bottom: 1px dashed #aaa;
        padding: 0 0 150px 0;
    }

    @media print {
        .pagebreak {
            page-break-after: always;
            border-bottom: none;
            padding: 0;
        }
    }
</style>